export const AUTH_LOGOUT = 'authLogout';
export const AUTH_REFRESH = 'authRefresh';
export const AUTH_REQUEST = 'authRequest';
export const AUTH_GOOGLE = 'authGoogle';
export const AUTH_FACEBOOK = 'authFacebook';
export const AUTH_SUCCESS = 'authSuccess';
export const REGISTRATION_REQUEST = 'registrationRequest';
export const SET_AUTH_ERRORS = 'setAuthErrors';
export const GET_USER_CONTACT_INFO = 'getUserContactInfo';
export const SET_USER_CONTACT_INFO = 'setUserContactInfo';

export const SET_PAGE_SIZE = 'setpageSize';
export const TOGGLE_SETTING_BY_KEY = 'toggleSettingByKey';

export const SET_REQUESTED_PATH = 'setRequestedPath';
export const SET_AVAILABLE_FILTER_TYPES = 'setAvailableFilterTypes';

export const GET_DESCRIPTION = 'getDescription';
export const SET_DESCRIPTION = 'setDescription';

export const UPDATE_USER_NOTIFICATIONS = 'updateUserNotifications';
export const SET_USER_NOTIFICATIONS = 'setUserNotifications';
export const UPDATE_NEW_NOTIFICATIONS_COUNT = 'updateNewNotificationsCount';
export const SET_NEW_NOTIFICATIONS_COUNT = 'setNewNotificationsCount';
